export default __webpack_public_path__ + "static/media/image-chair-child-w@2x.c5fa7dcc.png";